<template>
  <v-container>
    <v-form ref="form">
      <v-row dense class="mb-2">
        <v-col cols="12" sm="6">
          <div class="loc-field-label">No. Licencia</div>
          <div class="loc-field-value">{{ locSeleccionada.noLicencia }}</div>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="loc-field-label">Nombre instancia</div>
          <div class="loc-field-value">{{ locSeleccionada.nombreInstancia }}</div>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="loc-field-label">Titular</div>
          <div class="loc-field-value">{{ locSeleccionada.titular }}</div>
        </v-col>
        <v-col cols="12" sm="6">
          <div class="loc-field-label">Representante legal</div>
          <div class="loc-field-value">{{ locSeleccionada.representanteLegal }}</div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="loc-field-label">Vigencia</div>
          <div class="loc-field-value">{{ locSeleccionada.vigencia || '—' }}</div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="loc-field-label">Fecha de alta</div>
          <div class="loc-field-value">{{ locSeleccionada.fechaAlta || '—' }}</div>
        </v-col>
        <v-col cols="12" sm="4">
          <div class="loc-field-label">Fecha de trámite</div>
          <div class="loc-field-value">{{ locSeleccionada.fechaTramite || '—' }}</div>
        </v-col>
      </v-row>

      <v-divider class="mb-4" style="border-color: rgba(108,92,231,0.2)" />

      <v-row>
        <v-col cols="12" sm="6">
          <v-menu
            v-model="menuFechaBaja"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="ui-form-field"
                v-model="fechaBajaFormatted"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
                hint="Formato de fecha: DD/MM/YYYY"
                :rules="[rules.required]"
              >
                <template v-slot:label>Fecha de baja <span class="red--text">*</span></template>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="fechaBaja"
              @input="menuFechaBaja = false"
              locale="es"
              no-title
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6">
          <v-file-input
            class="ui-form-field"
            v-model="oficioAutorizacion"
            accept=".pdf,.jpg,.jpeg,.png"
            prepend-icon=""
            prepend-inner-icon="mdi-paperclip"
            rounded
            filled
            dense
            color="secondary"
            background-color="transparent"
            :rules="[rules.required]"
          >
            <template v-slot:label>Oficio de autorización de baja <span class="red--text">*</span></template>
          </v-file-input>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-2">
        <v-col cols="auto">
          <TextButton :loading="loading" @click="registrarBaja"> Registrar baja </TextButton>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },

  props: {
    locSeleccionada: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      menuFechaBaja: false,
      fechaBaja: null,
      oficioAutorizacion: null,
      rules: {
        required: (v) => !!v || 'Campo obligatorio',
      },
    }
  },

  computed: {
    fechaBajaFormatted() {
      return this.fechaBaja ? moment(this.fechaBaja).format('DD/MM/YYYY') : ''
    },
  },

  methods: {
    ...mapActions('licenciaOficialColectiva', ['bajaLoc']),

    async registrarBaja() {
      const valid = await this.$refs.form.validate()
      if (!valid) return

      this.loading = true
      try {
        const formData = new FormData()
        formData.append('fechaBaja', moment(this.fechaBaja).format('DD/MM/YYYY'))
        formData.append('OficioAutorizacionBaja', this.oficioAutorizacion)
        formData.append('activo', false)

        await this.bajaLoc({ idLoc: this.locSeleccionada.idLoc, formData })
        this.$emit('close')
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.loc-field-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: rgba(224, 224, 224, 0.5);
  margin-bottom: 2px;
}

.loc-field-value {
  font-size: 0.9rem;
  color: #e0e0e0;
  font-weight: 500;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}
</style>
